import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SyncFilesService } from 'app/sync-files/services/sync-files.service';
import { BzgToastService } from 'bz-genome-angular';

@Component({
  selector: 'biz-import-sync-files-modal',
  templateUrl: './import-sync-files-modal.component.html',
  styleUrls: ['./import-sync-files-modal.component.scss']
})

export class ImportSyncFilesModalComponent implements OnInit {
  @ViewChild('fileUpload') fileUploader: ElementRef;
  @Output() onFinish = new EventEmitter();
  
  FilePath: string;
  FileToImport: File;
  filesWithError: any[];
  status: string;
  isLoading = false;
  messageStatus: string;


  constructor(private _syncFilesService: SyncFilesService,
    private _translateService: TranslateService,
    private _toastService: BzgToastService) { }

  ngOnInit() {
  }

  public closeModal() {
    this.onFinish.emit();
  }

  public addFiles() {
    this.fileUploader.nativeElement.click();
  }

  public onFilesAdded() {
    if(this.fileUploader.nativeElement.files[0])
    {
      this.FileToImport = this.fileUploader.nativeElement.files[0];
      this.FilePath = this.FileToImport.name;
      this.fileUploader.nativeElement.value = '';
    }
  }

  async onImport() {
    this.showLoading('importing');
    var response = await this._syncFilesService.executeImport(this.FileToImport).catch(error => {
      this.closeModal();
    });

    response = JSON.parse(response);
    if (response.Issues && Object.keys(response.Issues).length > 0) {
      this.filesWithError = await this.extractFilesWithError(response);
    }

    if (!this.filesWithError || this.filesWithError.length === 0) {
      if (!response.ErrorLog || response.ErrorLog.trim() == "") {
        this.status = 'success';
        this.closeModal();
        this.ShowSuccess();
      }else{
        this.status = 'error';
        this.closeModal();
        this.ShowError(response.ErrorLog);
      }

    } else {
      this.status = 'error';
    }

    this.hideLoading();
  }

  private ShowSuccess() {
    this._translateService.get('SYNC_FILES.IMPORT_SUCCESS').subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type: 'success',
          duration: 2000,
          verticalPosition: "bottom",
          horizontalPosition: "right"
        });
    });
  }

  private ShowError(message:string) {
    this._translateService.get(`SYNC_FILES.${message}`).subscribe((message: string) => {
      this._toastService.open(
        message,
        {
          type: 'error',
          duration: 0,
          verticalPosition: "bottom",
          horizontalPosition: "right"
        });
    });
  }

  private async extractFilesWithError(response: any) {
    let filesWithError = [];

    for (let entityKey in response.Issues) {
      let issues = response.Issues[entityKey];
      for (let issue of issues) {
        let errorMessage = await this.getErrorMessage(issue.IssueType);
        filesWithError.push({
          EntitySource: issue.EntityDisplayName,
          AttributeDisplayName: issue.AttributeDisplayName,
          FileName: issue.FileName,
          IdEntityValue: issue.IdEntityValue,
          Error: errorMessage,
        });
      }  
    }

    return filesWithError;
  }

  private getErrorMessage(errorCode: number): Promise<string> {
    return new Promise(resolve => {
      this._translateService.get(`SYNC_FILES.ERROR.${errorCode}`).subscribe((message: string) => {
        resolve(message);
      });
    });
  }
  
  private showLoading(status: string) {
    this.messageStatus = status;
    this.isLoading = true;
  }

  private hideLoading() {
    this.messageStatus = '';
    this.isLoading = false;
  }

}
